// Mirrors the sample's ksh() helper.
export const ksh = (n) => Number(n || 0).toLocaleString("en-KE");

export const initials = (name) =>
  name
    .split(/[\s&]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();

export const stars = (n) => "★".repeat(n) + "☆".repeat(5 - n);

export const ytThumb = (id) => `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
